const initialState ={
    docs: []
}

export const docsReducer=(state=initialState, action) => {
    
    switch (action.type) {
        case 'GET_ALL_DOCS' : return{
            ...state,
            docs : action.payload
        }
        default : return state
    }
}